// The English table (ship 3): the same keys, kinds and placeholders as th.js — apps/coaster/test/tables.test.js
// holds the two together. Depths, edge heights and z numbers arrive as parameters, never typed here.
const S = {
  styleGroup: "Coaster style",
  styles: {
    two: "Two-sided",
    logo: "Name / logo",
  },
  titles: {
    two: "Two-sided coaster",
    logo: "Coaster with a logo",
  },
  textHint: (lines, chars) => `Up to ${lines} lines, at most ${chars} characters each`,
  needFile: "Choose the logo’s SVG file — it stays on your device and is sent nowhere",
  artKept: "The logo lives only in this tab — after a refresh you must choose the file again",
  keptOld: "(still using the previous logo)",
  thumb: "Preview of the logo read",
  finish: "Logo style",
  finishes: {
    flush: "Flush",
    raised: "Raised",
    engraved: "Engraved",
  },
  finishNote: {
    flush: "Flush with the surface; the logo is a second colour — it needs a multi-colour printer and the 3MF file (the STL has no logo, so it is closed)",
    raised: (mm) => `Raised ${mm} mm — a single-nozzle printer gets two colours with one change (pick “single nozzle” under printing). The cup may rock if the logo is narrow`,
    engraved: (mm) => `Engraved ${mm} mm deep — one colour, no filament change`,
  },
  flushNeedsMulti: "Flush cannot print on a single nozzle — pick multi-colour printing",
  scale: "Logo size",
  logoColour: "Logo colour",
  logoPartNames: {
    body: "Coaster body",
    message: "Logo",
  },
  logoZNames: {
    body: "Body colour",
    message: "Logo colour",
  },
  logoEdgeNote: {
    lip: (mm) => `An edge ${mm} mm above the face keeps the drink in`,
    flat: "No edge — one level face",
  },
  gShape: "Shape and edge",
  gColour: "Colours and printing",
  a: "Side A word",
  b: "Side B word",
  wordHint: "Side B is the person sitting across; a short word reads best — 6 characters or fewer",
  rows: (n) => `${Math.floor(n)} rows`,
  shape: "Shape",
  shapes: {
    round: "Round",
    square: "Square",
  },
  views: {
    a: "Side A",
    b: "Side B",
    top: "From above",
  },
  d: {
    round: "Diameter",
    square: "Width",
  },
  mm: (v) => `${v} mm`,
  edge: "Edge",
  edges: {
    lip: "Raised edge",
    flat: "Flat edge",
  },
  edgeNote: {
    lip: "The edge stands 1.2 mm above the ridge and keeps the drink in",
    flat: "The edge is level with the ridge — the drink sits in the groove",
  },
  looks: "Colour themes",
  lookNames: {
    night: "Night",
    bee: "Black–yellow",
    wood: "Wood",
  },
  colour: {
    body: "Coaster body colour",
    message: "Text colour",
  },
  mode: "Printing",
  modes: {
    multi: "Multi (CFS / AMS)",
    swap: "Single nozzle",   // R72: the pill row's own label says it is how colour is printed
  },
  modeNote: {
    multi: "The 3MF has 2 parts — set each part’s colour in your slicer",
    swap: (z1, z2) => `Print at 0.2 mm layer height and schedule the filament changes shown under the picture (colour changes at ${z1} and ${z2} mm of the part)`,
    swapOne: (layer, z) => `Print at ${layer} mm layer height and schedule the filament change shown under the picture (the colour changes at ${z} mm of the part)`,
    lipToo: "The raised edge prints in the logo colour too",
    oneColour: "One colour — no colour change to set up",
  },
  zLine: (layer, filament, name) => `Before layer ${layer}, load ${filament} (${name})`,
  partNames: {
    body: "Coaster body",
    message: "Text",
  },
  zNames: {
    body: "Body colour",
    message: "Text colour",
  },
  size: (shape, d, h) => (shape === 'round' ? `Ø ${d} × ${h} mm` : `${d} × ${d} × ${h} mm`),
  hold: (ml) => `Holds about ${Math.round(ml)} ml`,
  loadingFont: (family, got, total) => (total > 0 ? `Loading ${family} ${got.toFixed(1)} / ${total.toFixed(1)} MB` : `Loading ${family} ${got.toFixed(1)} MB`),
  problem: {
    "few-rows-a": "The side A word is too long — the letters get few rows and are hard to read; try a shorter word",
    "few-rows-b": "The side B word is too long — the letters get few rows and are hard to read; try a shorter word",
    "light-body": "The coaster body should be darker than the text, or the text will not stand out",
    "thin-text": "The letters are very thin — some strokes may not print; try a larger logo or fewer characters",
    "same-colour": "The logo colour matches the coaster body — the logo will be invisible",
    "thin-parts": "The logo has thin strokes attached to thick parts — a slicer may cut them away",
    dropped: (p) => `Dropped ${p.n} pieces too thin to print from the logo`,
    "all-thin": "The logo is too thin for this size — no download",
    "art-too-complex": "The logo is too complex — no download",
  },
  dlstl: "STL",
  copied: "Copied",
  fatal: "Could not load the calculator — try refreshing the page",
  buildTimeout: "A build did not finish in 10 seconds and was restarted — try fewer characters or another font",

  // ship 3 piece c: the template's static text, baked per language by the build (was hardcoded Thai)
  beta: "Beta",
  aboutH2: "How the two-sided coaster works",
  aboutP1: "The ridges on the coaster hide a colour layer underneath: the person sitting on side A sees one word, the person opposite sees the other. From straight above, no text is visible. In simulation it reads best at roughly 40–100 cm away.",
  aboutP2: "Print at a 0.2 mm layer height. Use a dark body colour and a bright text colour; the grooves between ridges keep the cup from sticking and trap drips — wipe the water off after use.",
  aboutPrintNote: "This design has passed light and slicing simulation; real-print test results are pending.",
  aboutLogoP: "The “Name / logo” style is a flat coaster: put text or your shop's SVG logo file on it — flush, raised or engraved. The logo file stays on your device and is sent nowhere. Limits: lines or gaps between letters narrower than the nozzle may be dropped by the slicer or print fused together — check the preview in your slicer before printing. This style has been sliced in OrcaSlicer but not print-tested.",
  // the words a page opened with no link starts on (ruling R69): English, Latin — no download on open
  start: {
    a: "Cheers",
    b: "LOVE",
  },
};
export default S;
